export const environment = {
    production: true,
    useMock: false,
    apiHost: 'https://rec-avwinfra-paula-frontend.azurewebsites.net',
    redirectUri: 'https://rec-avwinfra-paula-frontend.azurewebsites.net/authenticate',
    imageOptions: {
        imageWidth: 1600,
        imageHeight: 1200,
    }
};
